import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';
import type {SelfEmploymentProvider} from './fetchEmployment';

type ActivateEmploymentOperation = paths['/executor_web/employments/activate']['post'];

export type ActivateEmploymentRequest = NonNullable<
	NonNullable<ActivateEmploymentOperation['requestBody']>['content']['application/json']
> & {
	/** Только СМЗ: бэк выбирает профиль в selfEmploymentProfiles. */
	provider?: SelfEmploymentProvider;
};
export type ActivateEmploymentResponse =
	ActivateEmploymentOperation['responses'][200]['content']['application/json'];
export type ActivateEmploymentErrorResponse =
	ActivateEmploymentOperation['responses'][400]['content']['application/json'];

/** POST `/executor_web/employments/activate` — см. `paths['/executor_web/employments/activate']` в auth swagger */
export function activateEmployment(request: ActivateEmploymentRequest, signal?: AbortSignal) {
	return axiosInstance.post<ActivateEmploymentResponse>('employments/activate', request, {signal});
}
